import EditDialogProvider from "src/features/DialogProvider";
import DeleteDialogProvider from "src/features/DialogProvider";
import EditButton from "./components/EditButton";
import DeleteButton from "./components/DeleteButton";
import EditDialog from "./components/EditDialog";
import DeleteDialog from "./components/DeleteDialog";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { TableRow } from "src/views/Ledger/LedgerBalanceMonitor/types/Table";
import { FeatureCode } from "@wallet-manager/node-types";
import { GetListRes } from "src/views/Ledger/LedgerBalanceMonitor/types/GetListRes";

function useOperationButton() {
  const renderOperationButtons = (
    params: GridRenderCellParams<any, TableRow & { rawData: GetListRes }, any>,
  ) => {
    return (
      <div
        style={{
          display: "flex",
          gap: "24px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <EditDialogProvider
          permissionKey={FeatureCode.FeaturesLedger.LedgerBalanceMonitor.Edit}
        >
          <EditButton />
          <EditDialog rowData={params.row} />
        </EditDialogProvider>
        <DeleteDialogProvider
          permissionKey={FeatureCode.FeaturesLedger.LedgerBalanceMonitor.Delete}
        >
          <DeleteButton />
          <DeleteDialog rowData={params.row} />
        </DeleteDialogProvider>
      </div>
    );
  };

  return { renderOperationButtons };
}

export default useOperationButton;
